import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import RegistersEditor from "./RegistersEditor";

const RegistersEditorPage = () => {
  const { registerId } = useParams();
  const navigate = useNavigate();
  const [register, setRegister] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = registerId === "new";

  const createEmptyRegister = () => ({
    _id: crypto.randomUUID(),
    name: "",
    type: "",
    description: "",
    asOfDateTime: new Date().toISOString(),
    entries: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchRegister = async () => {
      if (isNew) {
        setRegister(createEmptyRegister());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://registers.poc.mrc.ai/api/registers/${registerId}`);
          const data = await res.json();
          setRegister(data);
        } catch (error) {
          console.error("Error fetching register:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchRegister();
  }, [registerId, isNew]);

  const handleSave = async (updatedRegister) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://registers.poc.mrc.ai/api/registers`
      : `https://registers.poc.mrc.ai/api/registers/${registerId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedRegister),
    });

    if (!res.ok) throw new Error("Failed to save register");

    const saved = await res.json();
    setRegister(saved);
  } catch (err) {
    console.error("Error saving register:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <RegistersEditor register={register} onClose={handleClose} isNew={isNew} />;
};

export default RegistersEditorPage;
